<template>
    <div>
        <div
            class="grid gap-12"
            :class="`grid-cols-${totalCols}`"
        >
            <template v-for="item in items">
                <div :class="`col-span-${item.cols}`">
                    <p class="font-semibold first-letter:uppercase">{{ item.title }}</p>
                </div>
            </template>
            <template v-for="channel in campaign.channels">
                <template v-for="item in items">
                    <div
                        class="flex items-center justify-start"
                        :class="`col-span-${item.cols}`"
                    >
                        <p>{{ item.method(channel) ?? '-' }}</p>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
import {mapState} from "pinia";
import Currency from "../../Currency.vue";
import {useMultiPostingStore} from "../../../state/modules/multiPosting";

export default {
    name: "Analytics",
    components: {Currency},
    computed: {
        ...mapState(useMultiPostingStore, ['campaign']),
        items() {
            return [
                {
                    title: this.$t('multi-posting.channels.title'),
                    method: this.getChannelName,
                    cols: 2,
                },
                {
                    title: this.$t('applications.applicants'),
                    method: this.getChannelApplications,
                    cols: 1,
                },
                {
                    title: this.$t('multi-posting.clicks.title'),
                    method: this.getChannelClicks,
                    cols: 1,
                },
                {
                    title: this.$t('multi-posting.cr.title'),
                    method: this.getChannelConversionRate,
                    cols: 1,
                },
                {
                    title: this.$t('multi-posting.cpa.title'),
                    method: this.getChannelCPA,
                    cols: 1,
                }
            ]
        },
        totalCols() {
            return this.items.reduce((acc, item) => {
                return acc + item.cols;
            }, 0);
        }
    },
    methods: {
        getChannelName(channel) {
            return channel.name;
        },
        getChannelApplications(channel) {
            if (channel.applications && channel.applications > 0) return channel.applications;
            return null;
        },
        getChannelClicks(channel) {
            if (channel.clicks && channel.clicks > 0) return channel.clicks;
            return null;
        },
        getChannelConversionRate(channel) {
            let applicants = this.getChannelApplications(channel);
            let clicks = this.getChannelClicks(channel);

            if (applicants && applicants > 0 && clicks && clicks > 0) {
                return ((clicks / applicants) * 100).toFixed(2) + ' %';
            }

            return null;
        },
        getChannelCPA(channel) {
            let applicants = this.getChannelApplications(channel);
            let price = channel.price?.amount;

            if (applicants && applicants > 0 && price && price > 0) {
                return (price / applicants).toFixed(2) + ' ' + channel.price?.currency;
            }

            return null;
        },
    },
}
</script>